<script setup lang="ts">
    const props = defineProps<{
        value: number | undefined;
        priceSizeSmall?: boolean;
        priceSizeMedium?: boolean;
    }>();

    const formattedPrice = computed(() => (props.value == null ? '' : useFormatPrice(props.value)));
</script>

<template>
    <p class="shared-price">
        <slot name="beforePrice" />
        <span
            class="price"
            :class="{ 'price-size-xxs': priceSizeSmall, 'price-size-m': priceSizeMedium }"
            >{{ formattedPrice }}</span
        >
        <slot name="afterPrice" />
    </p>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/product-price/shared-price.scss';
</style>
